import { formReducer, modelReducer } from 'react-redux-form'
import { combineReducers } from 'redux'

import * as h2Api from '../h2Api'
import * as actions from '../actions/combineAccountActions'

const initialFormState = {
  name: '',
  password: ''
}
const reducers = combineReducers({
  form: modelReducer('combineAccounts.form', initialFormState),
  forms: formReducer('combineAccounts', { form: initialFormState }),
  matchingAccountsRequest: h2Api.restReducer(actions.FIND_MATCHING_ACCOUNTS),
  combineAccountsRequest: h2Api.restReducer(actions.COMBINE_ACCOUNTS_BY_AUTH),
  combineAccountsChoiceRequest: h2Api.restReducer(actions.COMBINE_ACCOUNTS_BY_SELECTION)
})

export default reducers
